import {EMPTY, fromEvent, Observable} from 'rxjs';
import {delay, filter, first, mapTo, startWith} from 'rxjs/operators';

import {FrontWindow} from '../../libs/shared/helpers/src/browser/browserHelpers';

/** Returns an observable that emits once when the document is hidden. */
export function fromHiddenCallback(window: FrontWindow): Observable<undefined> {
  const {document} = window;

  // Despite the DOM types, a window can exist without a document, so check just in case.
  if (!document) {
    return EMPTY;
  }

  return fromEvent(document, 'visibilitychange').pipe(
    mapTo(undefined),
    startWith(undefined),
    filter(() => document.hidden),
    first(),
    delay(0),
  );
}
